export const V3IconProfileMasonry = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g stroke="#ABB0BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" clipPath="url(#V3IconProfileViewText)">
            <path d="M5.333 2.667H4c-.737 0-1.333.597-1.333 1.333v.667C2.667 5.403 3.263 6 4 6h1.333c.737 0 1.333-.597 1.333-1.333V4c0-.736-.596-1.333-1.333-1.333ZM5.333 8.667H4c-.737 0-1.333.597-1.333 1.333v2c0 .736.596 1.333 1.333 1.333h1.333c.737 0 1.333-.597 1.333-1.333v-2c0-.736-.596-1.333-1.333-1.333ZM12 2.667h-1.333c-.737 0-1.333.597-1.333 1.333v2c0 .736.596 1.333 1.333 1.333H12c.736 0 1.334-.597 1.334-1.333V4c0-.736-.598-1.333-1.334-1.333ZM12 10h-1.333c-.737 0-1.333.597-1.333 1.333V12c0 .736.596 1.333 1.333 1.333H12c.736 0 1.334-.597 1.334-1.333v-.667c0-.736-.598-1.333-1.334-1.333Z" />
        </g>
        <defs>
            <clipPath id="V3IconProfileViewText">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
);
